import { Component, Input, OnInit } from '@angular/core';
import { CheckEligibility } from 'src/app/models/check-eligibility';
import { TrainingEligibilityForm } from 'src/app/models/training-eligibility-form.model';

@Component({
    selector: 'app-training-eligibility-result',
    templateUrl: './training-eligibility-result.component.html',
    styleUrls: ['./training-eligibility-result.component.scss'],
    standalone: false
})
export class TrainingEligibilityResultComponent implements OnInit {

  @Input() identificationOption: string;
  @Input() contactOption: string;
  @Input() trainingEligibilityForm: TrainingEligibilityForm;
  @Input() checkEligibility?: CheckEligibility;
  @Input() currentLang: string;

  today = new Date()

  constructor() { }

  ngOnInit(): void {
  }

}
